//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { Placement } from 'tippy.js';

import { AlertIconWithMargin } from '@components/atoms/alert-icon/AlertIcon';
import Text from '@components/atoms/text/Text';
import { Mixins } from '@theme/mixins';

interface IOwnProps extends React.HTMLAttributes<HTMLDivElement> {
  value: string | number;
  alertText?: string | React.ReactElement;
  alertColor?: string;
  alertPlacement?: Placement;
}

type Props = IOwnProps & Partial<React.ComponentProps<typeof Text>>;

/**
 * The StatText atom renders a standardized line of text for a StatBubble main stat
 */
export const StatText = ({
  alertColor,
  alertPlacement,
  alertText,
  className,
  mixin = Mixins.Text.Title,
  value,
}: Props) => {
  return (
    <StatContainer className={className}>
      <Text mixin={mixin}>{value}</Text>
      {alertText && (
        <StyledAlertIconWithMargin
          alertText={alertText}
          color={alertColor}
          placement={alertPlacement}
        />
      )}
    </StatContainer>
  );
};

const StatContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledAlertIconWithMargin = styled(AlertIconWithMargin)(
  ({ theme }) => `
  position: relative;
  bottom: ${theme.spacings[1]};
`,
);

export default StatText;
